var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex text-right w-full"},[_vm._v(" "+_vm._s(_vm.price)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }